export default {
      id: "social-fb-usage",
      viewBox: "0 0 18 19",
      url: __webpack_public_path__ + "img/icons.svg#social-fb",
      toString: function () {
        return this.url;
      }
    }